(function () {
  function placeCvsBadgeAfterReviews() {
    var content = document.querySelector('.product-main-content');
    if (!content) return;

    var badge = content.querySelector('.cvs-badge');
    if (!badge || badge.dataset.cvsPlaced === 'true') return;

    var reviews = content.querySelector(
      '.shopify-app-block .loox-rating, .loox-rating.loox-widget, .jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge'
    );
    if (!reviews) return;

    var anchor = reviews.closest('.shopify-app-block') || reviews.closest('a') || reviews;
    if (!anchor || anchor.nextElementSibling === badge) {
      badge.dataset.cvsPlaced = 'true';
      return;
    }

    anchor.insertAdjacentElement('afterend', badge);
    badge.dataset.cvsPlaced = 'true';
  }

  function schedulePlacement() {
    placeCvsBadgeAfterReviews();
    window.setTimeout(placeCvsBadgeAfterReviews, 300);
    window.setTimeout(placeCvsBadgeAfterReviews, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePlacement);
  } else {
    schedulePlacement();
  }
})();
